const VERSION = "#__VERSION__#";

export {
	VERSION
};
